import { io, Socket } from "socket.io-client";
import { getAuthToken } from "@/lib/authCookies";

let chatSocket: Socket | null = null;

export const getSocketBaseUrl = (): string => {
    if (process.env.NEXT_PUBLIC_SOCKET_URL) {
        return process.env.NEXT_PUBLIC_SOCKET_URL;
    }
    const base = process.env.NEXT_PUBLIC_BASE_URL || "";
    try {
        const url = new URL(base);
        return `${url.protocol}//${url.host}`;
    } catch {
        return base.replace(/\/api.*$/, "").replace(/\/$/, "");
    }
};

export const getChatSocket = (token: string): Socket => {
    if (!chatSocket) {
        chatSocket = io(`${getSocketBaseUrl()}/chat`, {
            auth: { token },
            transports: ["websocket"],
            reconnection: true,
            reconnectionAttempts: 10,
        });
        chatSocket.io.on("reconnect_attempt", () => {
            const latestToken = getAuthToken();
            if (latestToken) chatSocket!.auth = { token: latestToken };
        });
    }
    return chatSocket;
};

export const reconnectChatSocket = (token: string): void => {
    if (!chatSocket) return;
    chatSocket.auth = { token };
    if (chatSocket.connected) chatSocket.disconnect();
    chatSocket.connect();
};

export const disconnectChatSocket = (): void => {
    chatSocket?.disconnect();
    chatSocket = null;
};
